var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"scroll",class:{show:_vm.isActive}},[_c('div',{attrs:{"id":"toTop"},on:{"click":function($event){return _vm.toTop(40)}}},[_vm._m(0),_c('div',{staticClass:"top-tip"},[_vm._v("TOP")])])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-icon"},[_c('i',{staticClass:"el-icon-arrow-up"})])
}]

export { render, staticRenderFns }